import { giphyDarkGrey } from '@giphy/js-brand'
import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { UPLOAD_BUTTON_LABEL } from '../../constants'
import { CreationToolsContext } from '../../manager'
import CreationToolGradient from '../../types/gradient'
import CreationToolStatus from '../../types/status'
import CreationToolUserRestriction from '../../types/user-restriction'
import { GradientButton } from '../buttons'
import { PauseIcon } from '../icons'
import ProgressBarComponent from '../progress-bar'
import { CreationToolUploadContext } from './manager'

const Button = styled(GradientButton)`
    box-sizing: content-box;
    font-size: 16px;
    height: 50px;
    margin: 0 -10px;
`

const ProgressButton = styled(Button)`
    background: ${giphyDarkGrey};
    cursor: default;
    position: relative;

    &:hover {
        animation: none;
    }

    &:active {
        opacity: 1;
    }

    span {
        text-shadow: 0 2px 6px rgba(0, 0, 0, 0.33);
        position: relative;
    }
`

const ProgressBar = styled(ProgressBarComponent)`
    left: 0;
    position: absolute;
    top: 0;
`

const PauseButton = styled(Button)`
    flex-shrink: 0;
    margin: 0;
    padding: 0;
    width: 50px;

    svg {
        display: block;
        height: 18px;
    }
`

const CreationUploadButton = () => {
    const { userRestrictionAccess } = useContext(CreationToolsContext)
    const { upload, uploadSources, pause, status, username } = useContext(CreationToolUploadContext)
    const [canUpload, setCanUpload] = useState<boolean>(false)
    const isLoggedIn = userRestrictionAccess.indexOf(CreationToolUserRestriction.LoggedInOnly) > -1
    const successfulUploadCount = uploadSources.filter(src => !!src.uploadedId).length
    const showChannelButton = username && uploadSources.length > 1 && successfulUploadCount === uploadSources.length
    const gradient = CreationToolGradient.colors(CreationToolGradient.IndigoPurple)

    useEffect(() => {
        const readySources = uploadSources.filter(source => !source.error && !source.uploadedId)
        if (isLoggedIn && status === CreationToolStatus.Idle && readySources.length > 0) {
            setCanUpload(true)
        } else {
            setCanUpload(false)
        }
    }, [uploadSources, status, isLoggedIn])

    // uploading state
    if (status !== CreationToolStatus.Idle) {
        const total = uploadSources.filter(source => !source.error).length
        const current = Math.min(uploadSources.filter(source => !!source.uploadedId).length + 1, total)
        const statusLabel = CreationToolStatus.description(status)
        return (
            <ProgressButton colors={gradient}>
                <ProgressBar progress={current / total}>
                    {total > 1 && (
                        <PauseButton colors={gradient} onClick={() => pause()}>
                            <PauseIcon />
                        </PauseButton>
                    )}
                </ProgressBar>
                <span>
                    {statusLabel}
                    {total > 1 ? ` ${current} of ${total}` : ``}
                </span>
            </ProgressButton>
        )
    }

    return showChannelButton ? (
        <Button
            {...{
                as: 'a',
                href: `/channel/${username}`,
                colors: gradient,
                target: '_blank',
                rel: 'noopener noreferrer',
            }}
        >
            Open Channel
        </Button>
    ) : (
        <Button colors={gradient} disabled={!canUpload} onClick={() => upload(uploadSources)}>
            {UPLOAD_BUTTON_LABEL}
        </Button>
    )
}

export default CreationUploadButton
